"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import Cookies from "js-cookie";

export default function VariantsTableClient() {
  const router = useRouter();

  useEffect(() => {
    const MAX_COMPARE = 4;
    let selectedVariants: string[] = [];

    // Update compare button state
    const updateCompareButtons = () => {
      const count = selectedVariants.length;
      const countElements = document.querySelectorAll('[data-compare-count]');
      const compareButtons = document.querySelectorAll('[data-compare-button]');
      
      countElements.forEach(el => {
        el.textContent = count.toString();
      });
      
      compareButtons.forEach(btn => {
        if (count <= 1) {
          btn.setAttribute('disabled', 'true');
        } else {
          btn.removeAttribute('disabled');
        }
      });
    };

    // Handle checkbox changes
    const handleCheckboxChange = (e: Event) => {
      const target = e.target as HTMLInputElement;
      
      if (target.type === 'checkbox' && target.name === 'compareVariant') {
        const variantId = target.value;
        const detailedSlug = target.getAttribute('data-detailed-slug');
        const variantSlug = target.getAttribute('data-variant-slug');
        
        if (target.checked) {
          // Check if limit reached
          if (selectedVariants.length >= MAX_COMPARE) {
            target.checked = false;
            return;
          }
          
          // Add to selection
          if (detailedSlug) {
            const key = variantSlug ? `${detailedSlug}+${variantSlug}` : detailedSlug;
            selectedVariants.push(key);
          }
        } else {
          // Remove from selection
          if (detailedSlug) {
            const key = variantSlug ? `${detailedSlug}+${variantSlug}` : detailedSlug;
            selectedVariants = selectedVariants.filter(v => v !== key);
          }
        }
        
        // Update cookie
        Cookies.set('selected_variant_slugs', JSON.stringify(selectedVariants), { path: '/' });
        
        // Update button states
        updateCompareButtons();
      }
    };

    // Handle compare button click
    const handleCompareClick = (e: Event) => {
      const target = e.target as HTMLElement;
      const button = target.closest('[data-compare-button]');
      
      if (button && selectedVariants.length > 1) {
        // Extract detailed slugs from selected variants
        const detailedSlugs = selectedVariants.map(v => v.split('+')[0]);
        const compareURL = detailedSlugs.join('-vs-');
        router.push(`/compare-cars/${compareURL}`);
      }
    };

    // Handle "View Less" click to uncheck the checkbox and scroll to top
    const handleViewLess = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const button = target.closest('button[data-scroll-to-top]');
      
      if (button) {
        e.preventDefault();
        
        // Uncheck the checkbox
        const checkbox = document.getElementById('showAllVariants') as HTMLInputElement;
        if (checkbox) {
          checkbox.checked = false;
        }
        
        // Scroll to top without changing URL
        const targetId = button.getAttribute('data-scroll-to-top');
        if (targetId) {
          const element = document.getElementById(targetId);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      }
    };

    // Add event listeners
    document.addEventListener('change', handleCheckboxChange);
    document.addEventListener('click', handleCompareClick);
    document.addEventListener('click', handleViewLess);
    
    // Initialize button state
    updateCompareButtons();
    
    return () => {
      document.removeEventListener('change', handleCheckboxChange);
      document.removeEventListener('click', handleCompareClick);
      document.removeEventListener('click', handleViewLess);
    };
  }, [router]);

  return null;
}
